import React from 'react';

import Icon from 'components/Icon';

const CHECKED_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <g data-name="Layer 2"><g data-name="Layer 1"><g><path id="Radio-Button-Checked" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM2,10a8,8,0,1,1,8,8A8,8,0,0,1,2,10Zm8,5a5,5,0,1,0-5-5A5,5,0,0,0,10,15Z" fill="#000001" fill-rule="evenodd"/></g></g></g>
  </svg>`;

const UNCHECKED_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Page-1"><path id="Radio-Button-UnChecked" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM2,10a8,8,0,1,1,8,8A8,8,0,0,1,2,10Z" fill="#000001" fill-rule="evenodd"/></g></g></g></svg>`;

const COMMON_ICON_STYLE = {
  'aria-label': '', // this is needed to prevent Jaws screen reader from focusing on the Icon in Windows 10/Chrome
  size: {
    width: '1.25rem',
    height: '1.25rem'
  }
};

const CHECKED_ICON_CONFIG = (disabled, $theme) => ({
  color: disabled ? $theme.checked.disabled.icon : $theme.checked.icon,
  ...COMMON_ICON_STYLE
});

const UNCHECKED_ICON_CONFIG = (disabled, hovered, $theme) => ({
  color: disabled ? $theme.unchecked.disabled.icon : hovered ? $theme.unchecked.hover.icon : $theme.unchecked.icon,
  ...COMMON_ICON_STYLE
});

export interface RadioButtonIconProps extends React.ComponentPropsWithRef<'div'> {
  disabled: boolean;
  checked: boolean;
  focused: boolean;
  hovered: boolean;
  $theme: Record<string, unknown>;
}

const RadioButtonIcon = (props: RadioButtonIconProps) => {
  const {
    disabled,
    checked,
    hovered,
    $theme
  } = props;
  const resolvedProps = checked ? CHECKED_ICON_CONFIG(disabled, $theme) : UNCHECKED_ICON_CONFIG(disabled, hovered, $theme);
  return <Icon {...props} {...resolvedProps}>{checked ? CHECKED_SVG : UNCHECKED_SVG}</Icon>;
};

export default RadioButtonIcon;
